import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './add-on.component.scss';
var AddOn = /** @class */ (function (_super) {
    tslib_1.__extends(AddOn, _super);
    function AddOn(element) {
        return _super.call(this, element) || this;
    }
    AddOn.prototype.init = function () {
    };
    AddOn.prototype.bindEvents = function () {
    };
    return AddOn;
}(Base));
export { AddOn };



//////////////////
// WEBPACK FOOTER
// ./components/add-on/add-on.component.ts
// module id = 82
// module chunks = 0